var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo 1",
    clipPath: "url(#clip0_213_17125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.4714 20.3143L45.9682 0H41.822L26.6295 17.6386L14.4953 0H0.5L18.8493 26.6727L0.5 47.9754H4.64642L20.6901 29.3484L33.5047 47.9754H47.5L28.4704 20.3143H28.4714ZM22.7923 26.9077L20.9331 24.2517L6.14043 3.11763H12.5091L24.447 20.1735L26.3061 22.8295L41.824 44.9995H35.4553L22.7923 26.9087V26.9077Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_17125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/x-logo.453b084a701830a0a412d71747812a33.svg";
export { ForwardRef as ReactComponent };